var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10Zm4.996-9.863L10.311 2.5l-4.686 7.637 4.686 2.721 4.685-2.721Zm.004.873-4.689 2.72-4.686-2.72 4.686 6.487L15 11.01Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.311 2.5v5.544l4.686 2.093L10.31 2.5Zm0 11.23v3.767L15 11.01l-4.689 2.72Z",
    fill: "#C1CCF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.311 12.858 4.686-2.72-4.686-2.093v4.813Z",
    fill: "#8198EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.625 10.137 4.686 2.721V8.045l-4.686 2.092Z",
    fill: "#C1CCF7"
  })));
};
export default SvgEth;